import { Colors } from "@/enums/Colors";
import { LazoPaths } from "@/enums/LazoPaths";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { LazoUser } from "@/models/LazoUser";
import LogoutIcon from "@mui/icons-material/Logout";
import { Box, Button, Typography, styled } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../lazo-ai-chat-components/Avatar";

interface Props {
  lazoUser: LazoUser;
}

const StyledButton = styled(Button)(({}) => ({
  color: Colors.WHITE,
  margin: 0,
  textTransform: "none",
  fontWeight: 400,
  fontSize: ".875rem",
  padding: "0",
}));

const LogoutStyledButton = styled(StyledButton, {
  shouldForwardProp: (prop) => prop !== "hovered",
})<{ hovered: boolean }>(({ hovered }) => ({
  display: hovered ? "flex" : "none",
  "@media (hover: none) and (pointer: coarse)": {
    display: "flex",
  },
}));

export const DrawerUserSection = (props: Props) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      sx={{
        paddingTop: "1rem",
        paddingBottom: "1.5rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between", // Always show both avatar+name and logout
        width: "10.750rem",
      }}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <StyledButton
        startIcon={
          <UserAvatar
            sx={{
              width: "32px !important",
              height: "32px !important",
              fontSize: "0.9rem !important",
              borderRadius: "50%",
            }}
            user={props.lazoUser.user}
          />
        }
        disabled
        sx={{
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "5.312rem",
          }}
        >
          {props.lazoUser.user.firstName + " " + props.lazoUser.user.lastName}
        </Typography>
      </StyledButton>
      <LogoutStyledButton
        sx={{ minWidth: 0, justifyContent: "flex-end" }}
        startIcon={<LogoutIcon />}
        onClick={() => {
          AuthService.logOut();
          sessionStorage.removeItem("sessionTracked");
          navigate(LazoPaths.INDEX);
        }}
        hovered={isHovered}
      />
    </Box>
  );
};
